{{#with context}}
if (!{{#if ../declareType}}{{ shortName }}{{else}}{{ identifier }}{{ iterationPropertiesList.last.brackets }}{{/if}}.randomize()) begin
  `uvm_error(get_type_name(), { {{#if ../declareType}}{{ shortName }}{{else}}{{ identifier }}{{ iterationPropertiesList.last.brackets }}{{/if}}.get_type_name(), " randomization failed." })
end
{{/with}}
